export const environment_prod = {
  PRODUCTION: true,
  APP_ENDPOINT: 'https://app.printix.net',
  CHECK_SERVER_HEALTH: 'https://api.printix.net/manage/health',
  INTERNAL_TEST_WAIT_TIME: 'https://api.printix.net/internal/testing/wait/',
  INTERNAL_TEST_RETURN_SET_STATUS_CODE: 'https://api.printix.net/internal/testing/status/',
  ENDPOINT_API: 'https://api.printix.net',
  ENDPOINT_TENANT_DOMAIN: 'https://auth.printix.net/oauth/authorize/tenant/',
  ENDPOINT_TENANT_LESS: 'https://auth.printix.net/oauth/authorize',
  ENDPOINT_SIGN_IN_MS: 'https://auth.printix.net/identity-providers/azure/signin?redirect_uri=',
  ENDPOINT_SIGN_IN_GOOGLE: 'https://auth.printix.net/identity-providers/google/signin?redirect_uri=',
  ENDPOINT_AUTH_TOKENS: 'https://auth.printix.net/oauth/token',
  ENDPOINT_GET_TENANT_USER: 'https://api.printix.net/v1/users/me',
  ENDPOINT_FIND_TENANT: 'https://api.printix.net/v1.2/find/',
  ENDPOINT_SIGN_OUT_BROWSER: 'https://auth.printix.net/logout',
  ENDPOINT_SIGN_OUT_NATIVE: 'https://auth.printix.net/oauth/logout',
  ENDPOINT_REVOKE_TOKEN: 'https://auth.printix.net/oauth2/revoke',
  ENVIRONMENT_STATE: 'production'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.